import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { fontWeight, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { globalStyle, style } from '@vanilla-extract/css';

export const targetsPageCard = style([
  {
    padding: space.s24,
  },
]);

export const targetsPageHeader = style([
  {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
  },
  responsiveStyle({
    mobile: {
      flexDirection: 'column',
      gap: space.s8,
    },
    tablet: {
      flexDirection: 'row',
      gap: space.s16,
    },
  }),
]);

export const targetsPageTitle = style([
  typography.titleLg,
  {
    marginBottom: space.s8,
  },
]);

export const targetsPageDescription = style([
  typography.bodyMd,
  {
    color: themeVars.container.foreground.secondary,
  },
]);

export const targetsPageAction = style([
  responsiveStyle({
    mobile: {
      marginLeft: 'auto',
    },
    tablet: {
      marginLeft: 0,
    },
  }),
]);

export const targetsPageSeparator = style([
  {
    margin: `${space.s28}px 0`,
  },
]);

export const targetsList = style([
  typography.bodyMd,
  {
    fontWeight: fontWeight.bold,
    display: 'flex',
    flexDirection: 'column',
    gap: space.s8,
    color: themeVars.container.foreground.secondary,
    paddingLeft: space.s24,
  },
]);

globalStyle(`${targetsList} > li span`, {
  position: 'relative',
  left: space.s16,
});
